import { render, staticRenderFns } from "./UserLessons.vue?vue&type=template&id=071a6d34"
import script from "./UserLessons.vue?vue&type=script&lang=js"
export * from "./UserLessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports